<template>
  <div class="container">
    <hr />
    <b-container class="bv-example-row mt-4">
      <b-row>
        <b-col class="text-center">&copy; {{ new Date().getFullYear() }} SmartBilling</b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
}
</script>




// WEBPACK FOOTER //
// src/AppFooter.vue